import React from "react";

type LoadingOverlayProps = {};

const LoadingOverlay: React.FunctionComponent<LoadingOverlayProps> = () => {
  return <p>Loading...</p>;
};

export default LoadingOverlay;
